import 'react-loading-skeleton/dist/skeleton.css';
let config;
export function setInitConfig(props) {
    config = props;
}
export function getInitConfig() {
    return config;
}
